import React, { RefObject, useEffect } from 'react';
import FragmentPlaceholder from '../../fragmentPlaceholder/fragmentPlaceholder';
import styles from './timeMachineHost.scss';

interface ITimeMachineHostProps {
    visible: boolean;
    anchorRef: RefObject<HTMLButtonElement | null>;
}

const TimeMachineHost = React.memo(function TimeMachineHost(props: ITimeMachineHostProps) {
    useEffect(() => {
        const updatePickerPosition = () => {
            const picker = document.querySelector('.tm-picker') as HTMLElement | null;
            const anchor = props.anchorRef.current;

            if (!picker || !anchor) {
                return;
            }

            if (!props.visible) {
                picker.hidden = true;
                picker.classList.remove(styles.tm_picker_visible);
                picker.classList.add(styles.tm_picker_hidden);
                return;
            }

            const rect = anchor.getBoundingClientRect();

            picker.hidden = false;
            picker.classList.remove(styles.tm_picker_hidden);
            picker.classList.add(styles.tm_picker_visible);
            picker.style.top = `${rect.bottom + 8}px`;
        };

        const timer = window.setTimeout(updatePickerPosition, 150);

        return () => {
            window.clearTimeout(timer);
        };
    }, [props.visible, props.anchorRef]);

    return (
        <FragmentPlaceholder
            src='/escid.esp.timemachine.api/fragment'
            ignoreErrors={true}
            timeout={1}
        />
    );
});

export default TimeMachineHost;